import { useTosaUserFeature } from '../../../hooks/useTosaUserFeature';
import { FeatureName } from '../../../utils';

import type { UseFeatureHook } from '../../../types';

interface UseVetCreatePlanSignupArgs {
  useFeature: UseFeatureHook;
}

export interface UseVetCreatePlanSignupReturn {
  isVetCreatePlanSignupOn: boolean;
}

export function useVetCreatePlanSignup({
  useFeature,
}: UseVetCreatePlanSignupArgs): UseVetCreatePlanSignupReturn {
  const { treatment } = useTosaUserFeature({
    useFeature,
    featureName: FeatureName.VET_CREATE_PLAN_SIGNUP,
  });

  const isVetCreatePlanSignupOn = treatment === 'on';

  return {
    isVetCreatePlanSignupOn,
  };
}
